import { render } from "./AlbumViewsTable.vue?vue&type=template&id=2f6e9b70&scoped=true"
import script from "./AlbumViewsTable.vue?vue&type=script&lang=js"
export * from "./AlbumViewsTable.vue?vue&type=script&lang=js"

import "./AlbumViewsTable.vue?vue&type=style&index=0&id=2f6e9b70&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6e9b70"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QInput,QTable,QTr,QTd,QPagination});
